import { Component, Inject, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApplicationFacade, ShoppingCartService } from '@ridango/components';
import { CartPaymentCard } from '@ridango/components/lib/purchase/purchase.model';
import Env from '@ridango/core/env';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'gl-delete-saved-payment-method-modal',
    templateUrl: './delete-saved-payment-method-modal.component.html',
    styleUrls: ['./delete-saved-payment-method-modal.component.scss']
})
export class DeleteSavedPaymentMethodModalComponent {
    @Input() cards: CartPaymentCard[];
    deletedCards: CartPaymentCard[] = [];
    public assetsPath$ = this.applicationFacade.assetsPath$;

    constructor(
        private modalCtrl: ModalController,
        private applicationFacade: ApplicationFacade,
        @Inject('ENV') public env: Env,
        private shoppingCartService: ShoppingCartService
    ) {}

    get availableSavedPaymentCards() {
        return this.cards.filter((m) => !this.deletedCards.find((dm) => dm.id === m.id));
    }

    omMethodDelete(method) {
        this.deletedCards = [...this.deletedCards, method];
    }

    deletePaymentMethodsConfirm() {
        if (this.deletedCards.length > 0) {
            forkJoin(this.deletedCards.map((dc) => this.shoppingCartService.deleteSavedCard(dc.id))).subscribe({
                complete: () => {
                    this.modalCtrl.dismiss(true, 'cancel');
                }
            });
        } else {
            this.modalCtrl.dismiss(null, 'cancel');
        }
    }

    cancel() {
        this.modalCtrl.dismiss(null, 'cancel');
    }
}
